<template>
  <div class="relative flex-1 overflow-hidden">
    <Transition :name="`sp-slide-horizontal-${direction}`">
      <div
        :key="activeDef.id"
        class="absolute inset-0"
        :class="activeDef.contentClass"
      >
        <component :is="activeDef.component" @close="close" />
      </div>
    </Transition>
  </div>
</template>

<script setup lang="ts">
import { computed, ref, watch } from "vue";
import { useSidepanel } from "@/composables/useSidepanel";

const props = defineProps({
  modeId: { type: String, required: true },
});

const { modeDefs, close } = useSidepanel();

const activeDef = computed(
  () => modeDefs.value.get(props.modeId) ?? modeDefs.value.get("ai")!,
);

// Tab order (def.order) drives the slide: moving right slides "backward",
// moving left slides "forward".
const direction = ref<"forward" | "backward">("forward");
watch(
  () => props.modeId,
  (newMode, previousMode) => {
    const from = modeDefs.value.get(previousMode)?.order ?? 0;
    const to = modeDefs.value.get(newMode)?.order ?? 0;
    if (from !== to) {
      direction.value = to > from ? "backward" : "forward";
    }
  },
  { flush: "pre" },
);
</script>

<style scoped>
.sp-slide-horizontal-forward-enter-active,
.sp-slide-horizontal-forward-leave-active,
.sp-slide-horizontal-backward-enter-active,
.sp-slide-horizontal-backward-leave-active {
  transition:
    transform 280ms ease-in-out,
    opacity 280ms ease-in-out;
}
.sp-slide-horizontal-forward-enter-from {
  transform: translateX(40px);
  opacity: 0;
}
.sp-slide-horizontal-forward-leave-to {
  transform: translateX(-40px);
  opacity: 0;
}
.sp-slide-horizontal-backward-enter-from {
  transform: translateX(-40px);
  opacity: 0;
}
.sp-slide-horizontal-backward-leave-to {
  transform: translateX(40px);
  opacity: 0;
}
</style>
